import Events from "./index"
import { CheckoutEvents } from "./types"

//
// CHECKOUT EVENT HELPERS
//
export const triggerPaymentResultEvent = (isRoutingToPaymentResult: boolean) => {
    Events.trigger(CheckoutEvents.PAYMENT_RESULT_EVENT, isRoutingToPaymentResult)
}

export const triggerIsSubscribiningKlaviyoEmail = (isSubscribing: boolean) => {
    Events.trigger(CheckoutEvents.IS_SUBSCRIBING_KLAVIYO_EMAIL, isSubscribing)
}
//
// SUBSCRIPTION HELPERS
//
export const subscribeToIsSubscribiningKlaviyoEmail = (
    callback: (isSubscribing: boolean) => void
) => {
    return Events.subscribe(CheckoutEvents.IS_SUBSCRIBING_KLAVIYO_EMAIL, callback)
}

export const subscribeToPaymentResultEvent = (
    callback: (isRoutingToPaymentResult: boolean) => void
) => {
    return Events.subscribe(CheckoutEvents.PAYMENT_RESULT_EVENT, callback)
}

// Helper to unsubscribe from any event
export const unsubscribeFromEvent = (event: string, handle: number) => {
    return Events.unsubscribe(event, handle)
}

// Export the main Events instance
export { CheckoutEvents } from "./types"
export { Events }
